export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'I wanted a more organized way to approach technical requests and everyday engineering tasks. The SIGMA SMART™ prompts gave me a clear starting point for structuring instructions, exploring possible solutions, and organizing my workflow.',
    name: 'Michael R.',
    location: 'Houston, Texas, USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/d127ad2a-397a-4934-8c9b-1d6edb5e8d2a.jpg',
  },
  {
    quote:
      'The calculation review and technical analysis prompts stood out to me. They help structure the review process and identify assumptions or missing information that need further attention. It’s a practical resource to support my engineering workflow.',
    name: 'Daniel W.',
    location: 'Manchester, United Kingdom',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/dc62d71a-5253-49aa-82b5-f47f91a1c053.jpg',
  },
  {
    quote:
      'What I like about this toolkit is the variety of engineering applications covered. From troubleshooting and automation to technical reports, the prompts provide a useful framework for getting started with AI while keeping professional judgment and verification essential.',
    name: 'James T.',
    location: 'Toronto, Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e4e686a5-5c4b-455e-b981-bf941320e7fe.jpg',
  },
];
